var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import { tokens } from '../tokens';
// Mappings between paragraph's sizes and variants, and design tokens
var sizeMap = {
    small: {
        fontSize: tokens.fontSizes.small,
    },
    medium: {
        fontSize: tokens.fontSizes.medium,
    },
    large: {
        fontSize: tokens.fontSizes.large,
    },
};
var regularVariantMap = {
    primary: {
        color: tokens.colors.navy,
    },
    secondary: {
        color: tokens.colors.navySubtleTextOnLight,
    },
};
var invertedVariantMap = {
    primary: {
        color: tokens.colors.white,
    },
    secondary: {
        color: tokens.colors.navySubtleTextOnDark,
    },
};
export function paragraphStyle(_a) {
    var variant = _a.variant, size = _a.size, inverted = _a.inverted;
    var variantMap = inverted ? invertedVariantMap : regularVariantMap;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    line-height: ", ";\n    margin-bottom: ", ";\n    color: ", ";\n    font-size: ", ";\n  "], ["\n    line-height: ", ";\n    margin-bottom: ", ";\n    color: ", ";\n    font-size: ", ";\n  "])), tokens.lineHeights.relaxed, tokens.spacing.small, variantMap[variant].color, sizeMap[size].fontSize);
}
var templateObject_1;
